export default __webpack_public_path__ + "546bf58bd7a3c157f56eb091003c15f8.svg";